import React from "react";
import ExpandCell from "./ExpandCell";

const bindExpandCell = toggleIsExpandedHOF => props => (
  <ExpandCell {...props} toggleIsExpandedHOF={toggleIsExpandedHOF} />
);

export default bindExpandCell;
